import "./PhotoGalleryStyles.css";
import PhotoGalleryData from "./PhotoGalleryData";
import PhotoGallery1 from "../../../../Assets/Multimedia/PhotoGallery/Photogallery-2025.png";
import PhotoGallery2 from "../../../../Assets/Multimedia/PhotoGallery/Photogallery-2026.jpg";

function PhotoGalleryAll() {
  return (
    <div className="page-container">
      <h1>POUSH MELA IN YEARS</h1>
      <p>Select Your Galery To View</p>
      <div className="page-overview-cart">
        <PhotoGalleryData
          image={PhotoGallery1}
          heading="POUSH MELA - 2025"
          text={
            <>
              <div className="text-line">
                <span className="bold-navy">Date:</span>January 25, 2025 (5 AM
                to 9 PM)
              </div>
              <div className="text-line">
                <span className="bold-navy">Venue:</span> Xpression Center, 7667
                Lake Worth Rd. Lake Worth, FL-33064
              </div>
            </>
          }
          url="/poush2025"
        />
        <PhotoGalleryData
          image={PhotoGallery2}
          heading="POUSH MELA - 2026"
          text={
            <>
              <div className="text-line">
                <span className="bold-navy">Date:</span> January 10, 2026 (5 AM
                to 10 PM)
              </div>
              <div className="text-line">
                <span className="bold-navy">Venue:</span> South County Civic
                Center, 16700 Jog Rd, Delray Beach, FL 33446
              </div>
            </>
          }
          url="/poush2026"
        />
      </div>
    </div>
  );
}

export default PhotoGalleryAll;
